import { render } from "./LeaveCarryForwardPayouts.vue?vue&type=template&id=21fbd5a3&scoped=true"
import script from "./LeaveCarryForwardPayouts.vue?vue&type=script&lang=js"
export * from "./LeaveCarryForwardPayouts.vue?vue&type=script&lang=js"

import "./LeaveCarryForwardPayouts.vue?vue&type=style&index=0&id=21fbd5a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fbd5a3"]])

export default __exports__